import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-542e7eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "years" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = { class: "status-icon" }
const _hoisted_7 = { class: "status-text" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-section-title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Address:")
], -1))
const _hoisted_11 = { class: "address" }
const _hoisted_12 = {
  key: 0,
  class: "card-section"
}
const _hoisted_13 = { class: "card-section-title" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "record"
}
const _hoisted_18 = {
  key: 1,
  class: "no-record"
}
const _hoisted_19 = {
  key: 1,
  class: "card-section"
}
const _hoisted_20 = { class: "card-section-title" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "record"
}
const _hoisted_25 = {
  key: 1,
  class: "no-record"
}
const _hoisted_26 = {
  key: 2,
  class: "card-section"
}
const _hoisted_27 = { class: "card-section-title" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "record"
}
const _hoisted_32 = {
  key: 1,
  class: "waitingEEApproval"
}
const _hoisted_33 = {
  key: 2,
  class: "no-record"
}
const _hoisted_34 = {
  key: 3,
  class: "card-section buttons"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Forms:", -1))
const _hoisted_36 = { class: "buttons" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "buttons" }
const _hoisted_40 = { class: "tag" }
const _hoisted_41 = { class: "tag" }
const _hoisted_42 = {
  key: 4,
  class: "card-section"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Trust Compliance Review:", -1))
const _hoisted_44 = { class: "buttons" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf" }, null, -1))
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf" }, null, -1))
const _hoisted_49 = { class: "buttons" }
const _hoisted_50 = { class: "tag" }
const _hoisted_51 = { class: "tag" }
const _hoisted_52 = {
  key: 5,
  class: "card-section"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "External Examiner Report:", -1))
const _hoisted_54 = { class: "buttons" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "tag" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Resubmission: (If required)", -1))
const _hoisted_59 = { class: "buttons" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 6,
  class: "card-footer"
}

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_Popover = _resolveComponent("Popover")
  const _component_AssignTrustContact = _resolveComponent("AssignTrustContact")
  const _component_AppointCoordinator = _resolveComponent("AppointCoordinator")
  const _component_AppointAndTerminateEE = _resolveComponent("AppointAndTerminateEE")
  const _component_AccessDenied = _resolveComponent("AccessDenied")
  const _component_LoggedInElsewhere = _resolveComponent("LoggedInElsewhere")
  const _component_ActionModal = _resolveComponent("ActionModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.checkingFormStatus)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.getPracticeNameDisplay(_ctx.practice)), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.practice.complianceYear?.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("i", {
            class: "fas fa-circle",
            style: _normalizeStyle(_ctx.statusColorCSS(_ctx.practice.progress?.id))
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.practice.progress?.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.practice.practice?.address), 1)
      ]),
      (_ctx.dashboardType === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h5", null, [
                _createTextVNode("Trust Coordinator: "),
                _createVNode(_component_Popover, {
                  popover: _ctx.$getPopover('PrincipalDashboard-TrustCoordinator', 1)
                }, null, 8, ["popover"])
              ]),
              _createElementVNode("button", {
                class: "btn-icon btn-secondary sml",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.editingTrustCoordinator = true)),
                disabled: _ctx.practice.isTrustContact
              }, _hoisted_16, 8, _hoisted_14)
            ]),
            (_ctx.practice.practice?.trustCoordinator?.firstName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.trustCoordinator?.lawId) + " - " + _toDisplayString(_ctx.practice.practice?.trustCoordinator?.firstName) + " " + _toDisplayString(_ctx.practice.practice?.trustCoordinator?.lastName), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.trustCoordinator?.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, " Please assign a Trust Coordinator "))
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h5", null, [
                _createTextVNode("Authorised Trust Contact: "),
                _createVNode(_component_Popover, {
                  popover: _ctx.$getPopover('PrincipalDashboard-AuthorisedTrustContact', 1)
                }, null, 8, ["popover"])
              ]),
              _createElementVNode("button", {
                class: "btn-icon btn-secondary sml",
                disabled: _ctx.practice.isTrustContact,
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.editingTrustContact = true)),
                onClose: _cache[2] || (_cache[2] = $event => {_ctx.editingTrustContact = false;})
              }, _hoisted_23, 40, _hoisted_21)
            ]),
            (_ctx.practice.practice?.trustContact?.firstName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.trustContact?.lawId) + " - " + _toDisplayString(_ctx.practice.practice?.trustContact?.firstName) + " " + _toDisplayString(_ctx.practice.practice?.trustContact?.lastName), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.trustContact?.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, " An Authorised Trust Contact should be assigned only if another person is assisting you with your trust records. "))
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h5", null, [
                _createTextVNode("External Examiner: "),
                _createVNode(_component_Popover, {
                  popover: _ctx.$getPopover('PrincipalDashboard-ExternalExaminer', 1)
                }, null, 8, ["popover"])
              ]),
              _createElementVNode("button", {
                class: "btn-icon btn-secondary sml",
                disabled: _ctx.practice.practice?.hasAwaitingEeRequestForm || !!this.userAccount.user.isTrustContact,
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.editingEE = true))
              }, _hoisted_30, 8, _hoisted_28)
            ]),
            (_ctx.practice.practice?.externalExaminer?.firstName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.externalExaminer?.lawId) + " - " + _toDisplayString(_ctx.practice.practice?.externalExaminer?.firstName) + " " + _toDisplayString(_ctx.practice.practice?.externalExaminer?.lastName), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.externalExaminer?.email), 1)
                ]))
              : (_ctx.practice.practice?.hasAwaitingEeRequestForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Awaiting approval of changes "))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, " An External Examiner should be assigned only if you are completing a Part B and are required to have your trust records externally examined. "))
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.clickPartA(_ctx.practice))),
                disabled: !_ctx.practice.partAButton?.isEnable
              }, [
                (!_ctx.isNotRequired(_ctx.practice?.partAButton?.label))
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(['fas', _ctx.practice?.partAViewEnable ? 'fa-file-pdf': 'fa-pencil'])
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.practice?.partAButton?.label), 1)
              ], 8, _hoisted_37),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.clickPartB(_ctx.practice))),
                disabled: !_ctx.practice.partBButton?.isEnable
              }, [
                (!_ctx.isNotRequired(_ctx.practice?.partBButton?.label))
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(['fas', _ctx.practice?.partBViewEnable ? 'fa-file-pdf': 'fa-pencil'])
                    }, null, 2))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.practice?.partBButton?.label), 1)
              ], 8, _hoisted_38)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.practice?.partAButton?.tag || ' '), 1),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.practice?.partBButton?.tag || ' '), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: !_ctx.practice.partAButton?.isEnable,
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.clickPartA(_ctx.practice)))
              }, [
                _hoisted_46,
                _createTextVNode(" " + _toDisplayString(_ctx.practice?.partAButton?.label), 1)
              ], 8, _hoisted_45),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: !_ctx.practice.partBButton?.isEnable,
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.clickPartB(_ctx.practice)))
              }, [
                _hoisted_48,
                _createTextVNode(" " + _toDisplayString(_ctx.practice?.partBButton?.label), 1)
              ], 8, _hoisted_47)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.practice?.partAButton?.tag || ' '), 1),
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.practice?.partBButton?.tag || ' '), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                style: {"width":"100%"},
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.clickEer(_ctx.practice))),
                disabled: !_ctx.practice?.eeRButton?.isEnable
              }, _toDisplayString(_ctx.practice?.eeRButton?.label), 9, _hoisted_55)
            ]),
            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.practice?.eeRButton?.tag || ' '), 1),
            _hoisted_57,
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                class: "btn btn-outline",
                style: {"width":"100%"},
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.clickResubmit(_ctx.practice))),
                disabled: !_ctx.practice.resubmissionRequestPartBButton.isEnable
              }, _toDisplayString(_ctx.practice.resubmissionRequestPartBButton.label), 9, _hoisted_60)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.dashboardType === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.getCardFooterText(_ctx.practice)), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editingTrustContact)
      ? (_openBlock(), _createBlock(_component_AssignTrustContact, {
          key: 1,
          practice: _ctx.practice
        }, null, 8, ["practice"]))
      : _createCommentVNode("", true),
    (_ctx.editingTrustCoordinator)
      ? (_openBlock(), _createBlock(_component_AppointCoordinator, {
          key: 2,
          modalOpened: _ctx.editingTrustCoordinator,
          practice: _ctx.practice,
          onClose: _cache[10] || (_cache[10] = $event => {_ctx.editingTrustCoordinator = false;})
        }, null, 8, ["modalOpened", "practice"]))
      : _createCommentVNode("", true),
    (_ctx.editingEE)
      ? (_openBlock(), _createBlock(_component_AppointAndTerminateEE, {
          key: 3,
          practice: _ctx.practice,
          onClose: _cache[11] || (_cache[11] = $event => (_ctx.editingEE = false))
        }, null, 8, ["practice"]))
      : _createCommentVNode("", true),
    (_ctx.showAccessDeniedModal)
      ? (_openBlock(), _createBlock(_component_AccessDenied, {
          key: 4,
          modalOpened: _ctx.showAccessDeniedModal,
          formStatus: _ctx.formStatus,
          onClose: _cache[12] || (_cache[12] = $event => (_ctx.closeAccessDeniedModal())),
          typeA: _ctx.typeA,
          typeB: _ctx.typeB,
          typeC: _ctx.typeC
        }, null, 8, ["modalOpened", "formStatus", "typeA", "typeB", "typeC"]))
      : _createCommentVNode("", true),
    (_ctx.showLoggedInElsewhereModal)
      ? (_openBlock(), _createBlock(_component_LoggedInElsewhere, {
          key: 5,
          modalOpened: _ctx.showLoggedInElsewhereModal,
          formStatus: _ctx.formStatus,
          onClose: _cache[13] || (_cache[13] = $event => (_ctx.closeLoggedInElsewhereModal())),
          onContinue: _cache[14] || (_cache[14] = $event => (_ctx.proceedToOvertakeSession(_ctx.isSignatoriesStatus))),
          additionalMsg: !_ctx.isSignatoriesStatus
        }, null, 8, ["modalOpened", "formStatus", "additionalMsg"]))
      : _createCommentVNode("", true),
    (_ctx.showActionModal)
      ? (_openBlock(), _createBlock(_component_ActionModal, {
          key: 6,
          practice: _ctx.practice,
          "onUpdate:practice": _cache[15] || (_cache[15] = $event => ((_ctx.practice) = $event)),
          actionType: _ctx.actionType,
          "onUpdate:actionType": _cache[16] || (_cache[16] = $event => ((_ctx.actionType) = $event)),
          onCloseModal: _cache[17] || (_cache[17] = $event => (_ctx.showActionModal = false)),
          onReloadData: _cache[18] || (_cache[18] = $event => (_ctx.reloadData()))
        }, null, 8, ["practice", "actionType"]))
      : _createCommentVNode("", true)
  ]))
}